// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "blocked_time_practitioner".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "blocked_time_practitioner" table (1:1 with a DB row, on the wire). */
export const blockedTimePractitionerAtomSchema = z.object({
    id: z.string(),
    blockedTimeId: z.string(),
    practitionerId: z.string(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=blockedTimePractitioner.js.map